import React from 'react';
import './ProfilePicker.less';
import {ProfilePickerTitle} from 'elements/profile-picker-title/ProfilePickerTitle';

export const ProfilePicker = ({title, children}) => {
	return (
		<div className="profile-picker">
			<div className="profile-picker__title">
				<ProfilePickerTitle text={title}/>
			</div>
			<div className="profile-picker__control">{children}</div>
		</div>
	);
};
